import { useStaticQuery, graphql } from "gatsby"

export const useRestaurantsData = () => {

  const { allContentfulRestaurant } = useStaticQuery(
    graphql`
      query CovidIndexQuery {
        allContentfulRestaurant (filter: {closed: {eq: false}}, sort: {fields: [score, name ], order: ASC}) {
          edges {
            node {
              id
              name
              logo {
                id
                file {
                  url
                }
              }
              giftCard
              takeOut
              delivery
              closed
              createdAt
              updatedAt
              instagramHandle
              specialOffer {
                childMarkdownRemark {
                  html
                }
              }
              skipTheDishes
              doordash
              uberEats
              tutti
              score
            }
          }
        }
      }
    `
  )

  return allContentfulRestaurant;
}